import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-lavender/50 px-5 py-10" data-id="element-246" data-mp="3fyhq1vsbkxc4">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-247" data-mp="2etacglpo0yoq">
        <p className="text-sm font-medium leading-relaxed text-plum sm:text-base" data-id="element-248" data-mp="29txn9ubbnfiz">
          ✨ Una experiencia visual, clara y sencilla para comenzar a acompañarte desde hoy.
        </p>
      </div>
    </section>;
}